import React from "react";
import { filter, isEmpty, omit, reject } from "lodash";

import { useNetworkSettings, useUpdateNetworkSettings } from "./api";
import PageTitle from "../../layout/PageTitle";
import NetworkSettingsForm from "./NetworkSettingsForm";
import { useDispatch } from "react-redux";
import publishAllVolatile from "helpers/files/publishAllVolatile";
import PageLoading from "components/shared/PageLoading";
import { resetValidationErrors } from "helpers/formValidations";
import {
  extractFirstValue,
  extractValues,
} from "components/shared/form/fields/Select";

function NetworkSettings() {
  const { isLoading, data: networkSettings } = useNetworkSettings();
  const dispatch = useDispatch();
  const { mutateAsync: updateNetworkSettings } = useUpdateNetworkSettings({
    onSuccess: () => {
      toastr.success(I18n.t("js.saving_successful"));
      window.location.reload(); // hard reload, to apply language settings
    },
  });

  const onSubmit = async (values) => {
    resetValidationErrors();

    console.log(values.language);

    let body = {
      ...values,
      language: extractFirstValue(values.language),
      // The SelectField resolve to an empty array if you clear the input
      category: isEmpty(values.category) ? null : values.category,
      detection_profile_field: extractFirstValue(
        values.detection_profile_field,
      ),
      // Send array of group_ids instead of an array with group objects
      group_promotion_config: {
        ...values.group_promotion_config,
        group_ids: extractValues(values.group_promotion_config.groups, "id"),
        group_category_ids: extractValues(
          values.group_promotion_config.group_category_ids,
        ),
      },
      guest_users_allow_chat: values.guest_users_allow_chat === "enabled",
      birthday_emails: {
        subject:
          values.birthday_emails.subject === ""
            ? null
            : values.birthday_emails.subject,
        text:
          values.birthday_emails.text === ""
            ? null
            : values.birthday_emails.text,
        enabled: values.birthday_emails.enabled === "true",
      },
      chat_message_allow_update: values.chat_message_allow_update === "true",
      chat_message_allow_destroy: values.chat_message_allow_destroy === "true",
      digest_sending_days: extractValues(values.digest_sending_days),
      directory_profile_fields: extractValues(values.directory_profile_fields),
      directory_filter_profile_fields: extractValues(
        values.directory_filter_profile_fields,
      ),
    };

    let image: object | null = null;

    if (
      !isEmpty(
        reject(values.birthday_emails.image, {
          state: "removed",
        }),
      )
    ) {
      const result = await publishAllVolatile({
        dispatch,
        values: {
          birthday_emails_image: reject(values.birthday_emails.image, {
            state: "removed",
          }),
        },
        storageDirectory: "assets",
      });

      image = result.birthday_emails_image[0];
    } else if (
      !isEmpty(filter(values.birthday_emails.image, { state: "removed" }))
    ) {
      image = {
        ...omit(values.birthday_emails.image[0], "id"),
        as: null,
      };
    }

    body = {
      ...body,
      birthday_emails: {
        ...body.birthday_emails,
        image,
      },
    };

    return updateNetworkSettings(body);
  };

  return (
    <>
      <PageTitle
        title={I18n.t("js.administration.network_settings.edit.title")}
      />
      <div>
        <div>
          {isLoading || isEmpty(networkSettings) ? (
            <PageLoading />
          ) : (
            <NetworkSettingsForm
              initialValues={networkSettings}
              onSubmit={onSubmit}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default NetworkSettings;
